import { Box, Drawer as MuiDrawer } from "@mui/material";
import { ReactNode } from "react";

export const Drawer = ({ open, children, onClose }: { open: boolean; children?: ReactNode; onClose: () => void }) => {
  return (
    <MuiDrawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 1050, height: "100%" }}>{children}</Box>
    </MuiDrawer>
  );
};
